<template>
    <div class="tenjityModule-switch" v-if="id">
        <input
            class="tenjityModule-switch-input"
            type="checkbox"
            :id="id"
            :checked="isChecked"
            @click="$event.stopPropagation()"
            :title="'switch'+id"
            :aria-label="ariaLabel"
        />
        <div class="tenjityModule-switch-label" :for="'switch'+id"></div>
    </div>
</template>

<script>
import uniqueId from 'lodash-es/uniqueId'

export default {
    name: "AccessibilitySwitch",
    props: {
        isChecked: {
            type: Boolean,
        },
        ariaLabel: {
            type: String,
            default: "Basculer l'option",
        },
    },
    data () {
        return {
            id: null
        }
    }, 
    mounted () {
        this.id = uniqueId();
    }
};
</script>

<style lang="scss" scoped></style>
